import * as ACTION_TYPES from '../types';

let initialState = {
  createTypeList: [],
  createType: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_CREATETYPES:
        return {...state, createTypeList: action.data };

      case ACTION_TYPES.DELETE_CREATETYPE:
        let newList = state.createTypeList.filter(createType => createType._id !== action.id);
        return {...state, createTypeList: newList };

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_CREATETYPE:
        return {...state, createTypeList: []};

      default:
        return state;
    }
  };